import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/edit.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm edit <pkg>[/<subpkg>...]
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/edit.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <p>{`Note: This command is unaware of workspaces.`}</p>
    <h3>{`Description`}</h3>
    <p>{`Selects a dependency in the current project and opens the package folder in
the default editor (or whatever you've configured as the npm `}<inlineCode parentName="p">{`editor`}</inlineCode>{`
config -- see `}<a parentName="p" {...{
        "href": "npm-config"
      }}><inlineCode parentName="a">{`npm-config`}</inlineCode></a>{`.)`}</p>
    <p>{`After it has been edited, the package is rebuilt so as to pick up any
changes in compiled packages.`}</p>
    <p>{`For instance, you can do `}<inlineCode parentName="p">{`npm install connect`}</inlineCode>{` to install connect
into your package, and then `}<inlineCode parentName="p">{`npm edit connect`}</inlineCode>{` to make a few
changes to your locally installed copy.`}</p>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`editor`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: The EDITOR or VISUAL environment variables, or 'notepad.exe' on
Windows, or 'vim' on Unix systems`}</li>
      <li parentName="ul">{`Type: String`}</li>
    </ul>
    <p>{`The command to run for `}<inlineCode parentName="p">{`npm edit`}</inlineCode>{` and `}<inlineCode parentName="p">{`npm config edit`}</inlineCode>{`.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/folders"
        }}>{`npm folders`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-explore"
        }}>{`npm explore`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-install"
        }}>{`npm install`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-config"
        }}>{`npm config`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/npmrc"
        }}>{`npmrc`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      